// Agent shell-drawer `window` CustomEvent names/types (stories 2-129/2-133/
// 2-144) — extracted from `components/agent/AgentPanel.tsx` by story
// 2-147wg (leaf-component/registry closure sweep), not invented here. These
// five exports are pure event-name strings/types with zero React/JSX
// dependency — `AgentPanel.tsx` (composite) re-exports them for its existing
// consumers (`AppShell.tsx`, its own allowlisted upward-import exception),
// while `TopBar.tsx`/`Sidebar.tsx` (layout-primitive) now import them from
// HERE instead of reaching up into `AgentPanel.tsx` — the real fix for the
// `design-language/no-upward-import` finding both files carried (P10 §4.4:
// a layout-primitive may import a same-or-lower-ranked layer only), not a
// new `UPWARD_IMPORT_ALLOWLIST` entry (this story's own Mandatory Migration
// Rules forbid new allowlist entries — a real architectural fix was owed
// instead, and this constants-only shape made one possible without touching
// any rendering behavior).

// Story 2-129 (UI-DS-00 §2/5): TopBar's agent-status trigger opens the panel
// via a `window` CustomEvent — no context, no shared store, no direct prop
// reach into AgentPanel's internals.
export const OPEN_AGENT_EVENT = 'sitewise:open-agent';

// The trigger is a STATUS PILL, not a bare toggle — it must show whether the
// assistant is idle, actively working, or blocked on a human decision, even
// while the panel itself is closed. AgentPanel dispatches its own
// status-changed event; TopBar/Sidebar only ever listen, never reach in.
export const AGENT_STATUS_EVENT = 'sitewise:agent-status';

// Story 2-144: fourth member, 'ready' — tokens.css's `[data-agent-status]`
// contract (2-131/2-133) has carried this value since before that story
// (idle/working → --primary, ready → --success, blocked → --warning).
export type AgentStatus = 'idle' | 'ready' | 'working' | 'blocked';

// Story 2-144: plain-language sentence per status, read by AgentPanel's own
// live region on every change (WCAG — the ambient glow/dot/pill treatment
// alone is not accessible).
export const AGENT_STATUS_ANNOUNCEMENT: Record<AgentStatus, string> = {
  idle: 'Assistant is idle.',
  ready: 'Assistant has a result ready to review.',
  working: 'Assistant is working…',
  blocked: 'Assistant needs your approval to continue.',
};

// Story 2-133: a SECOND one-directional event OUT of AgentPanel, same shape
// as AGENT_STATUS_EVENT above, but for the orthogonal open/closed axis
// tokens.css's own `data-shell-agent` contract names. TopBar's header
// trigger needs this to keep its `aria-expanded` truthful.
export const AGENT_OPEN_EVENT = 'sitewise:agent-open';
